import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import {DataGridPro, GridToolbar} from '@mui/x-data-grid-pro';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import EditIcon from '@mui/icons-material/Edit'; 

import { useSessionContext } from '../../../contexts/SessionContext';


export default function RealTimeSummary(props){
    //console.debug("RTS Break RealTimeSummary");
 
    const {userAuthToken, apiRoot} = useSessionContext();

    const history = useNavigate();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [data, setData] = useState([]);


    const fetchData = useCallback(() => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Inventory/GetRealTimePlantInventorySummary";
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    }, [apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        fetchData();
    }, []);  


    
    function handleClick(e, cellValues){
        history("/InventoryRealTimePlantDetail", {state: {idGuid:cellValues.row.plantIdGuid, display:cellValues.row.plant, mode:1}});
    }


    const columns = [
        {
            field: 'Edit',
            headerName: '',
            description:"Edit Project", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'plant', 
            headerName: "Plant", 
            description:"Plant Name", 
            flex:4,
            hideable:false,
        },
        {
            field: 'reelType', 
            headerName: "Reel Type", 
            description:"Reel Type", 
            flex:4,
            hideable:false,
        },
        {
            field: 'reelCount', 
            headerName: "Reels", 
            description:"Number of Reels",
            flex:1,
            type:"number"    
        },
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {}
        }
        else{
            return {}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return (
        <Box sx={{width:'100%', height:'100%', minHeight:'400px'}}>
            <DataGridPro
                pagination={true}
                slots={{toolbar: GridToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={data} 
                columns={columns} 
                getRowId={row => row.keyValue}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity() 

                }}                
            />
        </Box>
    );
}
